
export { SharedUiModule } from './ui.module';